import { useEffect } from "react";
import { Form, Input, Select, Button } from "antd";
import { ToastService } from "@shared/lib/services";
import { LEDGER_TYPE, IBriefLedger } from "@shared/lib/types/briefLedger";
import { InputNumber } from "@shared/ui/InputNumber";
const { Option } = Select;

interface EditBriefLedgerEntryProps {
  onSubmit: (values: any) => void;
  isSubmitting: boolean;
  onCancel: () => void;
  initialValues: IBriefLedger;
}

export function EditBriefLedgerEntry({
  onSubmit,
  isSubmitting,
  onCancel,
  initialValues,
}: EditBriefLedgerEntryProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        type: initialValues.type,
        subType: initialValues.subType,
        sellingCost: initialValues.sellingCost,
        serviceCost: initialValues.serviceCost,
        gstRate: initialValues.gstRate,
        remarks: initialValues.remarks,
      });
    }
  }, [initialValues, form]);

  const handleSubmit = (values: any) => {
    onSubmit({
      ...values,
      ledgerId: initialValues._id,
    });
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleSubmit}
      onFinishFailed={({ errorFields }) => {
        if (errorFields.length) {
          ToastService.error(
            "Error Submitting Form. Please fill all required fields."
          );
        }
      }}
    >
      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: "Type is required" }]}
      >
        <Select placeholder="Select Type">
          {Object.values(LEDGER_TYPE).map((type) => (
            <Option key={type} value={type}>
              {type}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="subType"
        label="Sub Type"
        rules={[{ required: true, message: "Sub Type is required" }]}
      >
        <Input disabled />
      </Form.Item>

      <Form.Item
        name="sellingCost"
        label="Selling Cost"
        rules={[{ required: true, message: "Selling Cost is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter Selling Cost"
          min={0}
        />
      </Form.Item>

      <Form.Item
        name="serviceCost"
        label="Service Cost"
        rules={[{ required: true, message: "Service Cost is required" }]}
      >
        <InputNumber
          style={{ width: "100%" }}
          type="number"
          placeholder="Enter Service Cost"
          min={0}
        />
      </Form.Item>

      <Form.Item
        name="gstRate"
        label="GST Rate (%)"
        rules={[{ required: true, message: "GST Rate is required" }]}
      >
        <InputNumber
          type="number"
          style={{ width: "100%" }}
          placeholder="Enter GST Rate "
          min={0}
          max={100}
        />
      </Form.Item>

      <Form.Item
        name="remarks"
        label="Remarks"
        rules={[{ required: true, message: "Remarks is required" }]}
      >
        <Input.TextArea
          placeholder="Enter Remarks"
          autoSize={{ minRows: 2, maxRows: 6 }}
        />
      </Form.Item>

      <Form.Item>
        <div
          style={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}
        >
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            htmlType="submit"
            disabled={isSubmitting}
            loading={isSubmitting}
          >
            {isSubmitting ? "Updating..." : "Update"}
          </Button>
        </div>
      </Form.Item>
    </Form>
  );
}
